import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import jwt_decode from "jwt-decode";
import {style} from "variables/Variables.jsx";
import '../../assets/css/react-confirm-alert/react-confirm-alert.css';
import NotificationSystem from "react-notification-system";
import {confirmAlert} from 'react-confirm-alert';
import {BeatLoader} from 'react-spinners';
import {Button, FormGroup, Input, Label} from "reactstrap";
import {css} from "@emotion/core";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import DatePicker from "react-datepicker";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import { date_range_config,user_activities,reactSelectStyles } from '../../helpers/utils.js';
import Dropzone from 'react-dropzone';
import Switch from "react-switch";
import "./campaign_module.css";
import qr_image from "assets/img/default_qr_image.png";
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
const d = new Date();
var year = d.getFullYear();
var month = d.getMonth();
var day = d.getDate();
class AddCampaign extends Component{
    constructor(props) {
        super(props);
        this.state = {
             _notificationSystem: null,
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            channel:"",
            channel_type:"",
            products:"",
            start_date: moment(new Date()).format('YYYY-MM-DD'),
            end_date: moment(new Date()).format('YYYY-MM-DD'),
            CampaignProductLists:[],
            productValue:"",
            product:"",
            ChannelTypeLists:[],
            channelTypeValue:"",
            channel_type:"",
            ChannelLists:[],
            channelValue:"",
            channel:"",
            BaseURL:"",
            LinkAppID:"",
            utm_code:'',
            utm_content:"",
            utm_term:moment(new Date()).format('YYYYMMDD'),
            qr_url:"",
            is_active:true,
            channel_value:"",
            channel_type_value:"",
            campaign_name:"",
            back_color:"",
            front_color:"",
            qr_outer_eyes_front_color:"",
            is_qr_generated:false,
            is_download_disabled:true,
            AdvertisementFiles:"",
            file_name:"",
            is_loading_qr: false,
            qr_file_path_sparcs:"",
            qr_file_path_s3:"",
            file_name: 'No file chosen',
            description:"",
            show_qr_image: true,
            qr_image:qr_image,
            qr_image_file_name: "",
            UtmContentLists:[],
            UtmContentValue:"",
            stateLists:[{"label": "All", "value": "All"}],
            stateValue:null,
            state_id:"",
            cityLists:[{"label": "All", "value": "All"}],
            cityValue:null,
            city_id:"",
            areaLists:[{"label": "All", "value": "All"}],
            areaValue:null,
            state_id:"",
            is_city_loading: false,
            is_area_loading: false,
            is_pan_india: false,
            is_pan_state: false,
            is_pan_city: false,
            redirect_type: 'App',
            web_url:''
        }

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({email:decoded.email});
        this.get_config();
        this.get_product();
        this.get_channel_type();
        this.get_channel();
        this.get_utm_content();
        this.get_state();
        this.get_city('');
        this.get_area('','');
    }

    get_state(){
        axios.get(config.get('API_URL')+'/filters/get-all-states/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = [{"label": "All", "value": "All"}]
                response.data.map((state, index) => {
                    mList.push({value: state.state_id, label: state.state_name})
                });
                this.setState({
                    stateLists:mList,

                })
            }
        });
    }

    changeState(login_type, optionSelected){
        let value='';
        let midArray = [];
        let is_pan_india = false;
        let is_pan_state = false;
        let is_pan_city = false;
        const prevSelectedOptions = this.state.stateValue;
        if (this.state.stateValue) {
         const deselectedOption = prevSelectedOptions.find(option => !optionSelected.includes(option));
         if (deselectedOption) {
            console.log('Deselected option:', deselectedOption);
            if(deselectedOption.value==="All") {
                optionSelected=[]
            }
          }
        }


        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)

                var index = this.state.stateLists.findIndex(obj => obj.value == mids.value);
                this.state.stateLists.move(index, 0).join(',');
           });
        }

        if(midArray.includes('All')) {
            midArray = '';
            is_pan_india = true;
            is_pan_state = true;
            is_pan_city = true;
            optionSelected = this.state.stateLists
        } else {

        }
        this.setState({
            state_id:midArray,
            stateValue:optionSelected,
            cityValue:[],
            city_id:'',
            area:'',
            areaValue: [],
            is_pan_india:is_pan_india,
            is_pan_state:is_pan_state,
            is_pan_city:is_pan_city
        });
        this.get_city(midArray)
        this.get_area(midArray,'')

    }
    get_city(state_id){
        var data = {
            state_id:state_id,
        }

        axios.post(config.get('API_URL')+'/filters/get-all-cities/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
             var mList = [{"label": "All", "value": "All"}]
            if(Array.isArray(response.data) && response.data) {

                response.data.map((city, index) => {
                    mList.push({value: city.city_id, label: city.city_name})
                });
                this.setState({
                    cityLists:mList,
                    is_city_loading: false
                })
            }
        });
    }

    changeCity(login_type, optionSelected){
        let value='';
        let midArray = [];
        let is_pan_state = false;
        let is_pan_city = false;
        const prevSelectedOptions = this.state.cityValue;
        if (this.state.cityValue) {
         const deselectedOption = prevSelectedOptions.find(option => !optionSelected.includes(option));
         if (deselectedOption) {
            console.log('Deselected option:', deselectedOption);
            if(deselectedOption.value==="All") {
                optionSelected=[]
            }
          }
        }
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.cityLists.findIndex(obj => obj.value == mids.value);
                this.state.cityLists.move(index, 0).join(',');
           });
        }
        if(midArray.includes('All')) {
            midArray = '';
            is_pan_state = true;
            is_pan_city = true;
            optionSelected = this.state.cityLists;
        }
        this.setState({
            city_id:midArray,
            cityValue:optionSelected,
            area:'',
            areaValue: [],
            is_pan_state:is_pan_state,
            is_pan_city:is_pan_city
        });
         this.get_area(this.state.state_id,midArray)

    }
    get_area(state_id, city_id){
        var data = {
            state_id:state_id,
            city_id:city_id
        }
        axios.post(config.get('API_URL')+'/filters/get-all-area/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            var mList = [{"label": "All", "value": "All"}]
            if(Array.isArray(response.data) && response.data) {

                response.data.map((area, index) => {
                    mList.push({value: area.po_area, label: area.po_area})
                });
                this.setState({
                    areaLists:mList,
                    is_area_loading: false
                })
            }
        });
    }

    changeArea(login_type, optionSelected){
        let value='';
        let midArray = [];
        let is_pan_city = false;
        const prevSelectedOptions = this.state.areaValue;
        if (this.state.areaValue) {
         const deselectedOption = prevSelectedOptions.find(option => !optionSelected.includes(option));
         if (deselectedOption) {
            console.log('Deselected option:', deselectedOption);
            if(deselectedOption.value==="All") {
                optionSelected=[]
            }
          }
        }

        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                var index = this.state.areaLists.findIndex(obj => obj.value == mids.value);
                this.state.areaLists.move(index, 0).join(',');
           });
        }
        if(midArray.includes('All')) {

            is_pan_city = true;
            optionSelected = this.state.areaLists;
        }
        this.setState({
            area:midArray,
            areaValue:optionSelected,
            is_pan_city:is_pan_city
        });
        //this._get_filtered_genie_transaction_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,

    }
    get_config() {
        var data = {
            service_name:"MarketingCampaign",
        }
        axios.post(config.get('API_URL')+'/CampaignModule/get_config/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
//             console.log(response.data.data[0])
//             console.log(response.data.utm_code)
            var env_var = response.data.data[0].variables
            this.setState({
                utm_code:response.data.utm_code,
                qr_url:env_var.BaseURL+'referrer='+response.data.utm_code,
                back_color:env_var.back_color,
                front_color: env_var.front_color,
                qr_outer_eyes_front_color:env_var.qr_outer_eyes_front_color
            })
        });
    }
    get_utm_content() {
        axios.get(config.get('API_URL')+'/CampaignModule/get_utm_content/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{

            }
        }).then(response => {
            response.data.map((utm_content_value, index) => {
                    this.state.UtmContentLists.push({value: utm_content_value.utm_content_value, label: utm_content_value.utm_content_value})
            });
            this.setState({
                loading2:false,
            })

        }).catch(err =>{
            console.log(err);
        })
    }
    changeUtmContent(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            UtmContentValue: optionSelected,
            utm_content: value,
            is_qr_generated:false,
            is_download_disabled:true
        });

    }
    get_product() {
        axios.get(config.get('API_URL')+'/CampaignModule/get_campaign_products/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{

            }
        }).then(response => {
            response.data.map((product, index) => {
                    this.state.CampaignProductLists.push({value: product.product_code, label: product.product_display_name})
            });
            this.setState({
                loading2:false,
            })

        }).catch(err =>{
            console.log(err);
        })
    }
    changeProduct(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        this.setState({
            productValue: optionSelected,
            product: value
        });
    }
    get_channel_type() {
        axios.get(config.get('API_URL')+'/CampaignModule/get_campaign_channel_types/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
            params:{

            }
        }).then(response => {
            response.data.map((channel, index) => {
                    this.state.ChannelTypeLists.push({value: channel.channel_type_code, label: channel.channel_type})
            });
            this.setState({
                loading2:false,
            })

        }).catch(err =>{
            console.log(err);
        })
    }
    changeChannelType(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        const value1 = optionSelected === null ? '' : optionSelected.label;
        this.setState({
            channelTypeValue: optionSelected,
            channel_type: value,
            channel_type_value: value1,
            channel:"",
            channelValue:null,
            channel_value:"",
            is_qr_generated:false,
            is_download_disabled:true
        });
       if(value!="") {
            setTimeout(function() {
                this.get_channel()
            }.bind(this), 200);
       }
//         if(value!='') {
//             this.setState({
//                 qr_url:this.state.qr_url+'&utm_source='+value1
//             })
//         } else {
//             const updatedUrl = this.state.qr_url.replace(/&utm_source=[^&]*/, '');
//             this.setState({ qr_url: updatedUrl });
//         }
    }
    get_channel() {
        var data = {
                channel_type:this.state.channel_type,
        }
        this.setState({
            ChannelLists:[]
        })
        axios.post(config.get('API_URL')+'/CampaignModule/get_campaign_channels/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((type, index) => {
                    this.state.ChannelLists.push({value: type.channel_code, label: type.channel})
                });
            }
        });
    }
    changeChannel(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        const value1 = optionSelected === null ? '' : optionSelected.label;

        this.setState({
            channelValue: optionSelected,
            channel: value,
            channel_value: value1,
            is_qr_generated:false,
            is_download_disabled:true
        });


//         if(value!='') {
//             this.setState({
//                 qr_url:this.state.qr_url+'&utm_campaign='+value1
//             })
//         }else {
//             const updatedUrl1 = this.state.qr_url.replace(/&utm_campaign=[^&]*/, '');
//             this.setState({ qr_url: updatedUrl1 });
//         }
    }
    onChangeInput(e) {
        this.setState({ [e.target.name]: e.target.value });
//         if(e.target.name==='utm_term' || e.target.name=='utm_content')
//         {
//             this.setState({
//                 is_qr_generated:false,
//                 is_download_disabled:true
//             })
//         }
    }
    onPreviewDropFile = (files) => {
        let fileData = [];
        fileData = files;
//         console.log(fileData);
//         console.log(files[0].name);

        if (files.length > 0) {
            this.setState({
                AdvertisementFiles: fileData,
                file_name: files[0].name,
            });
        }
        else {
            this.handleNotificationClick("tr", 3, "Please upload a valid file type");
        }
    }
    updateStatus(checked) {
        this.setState({
            is_active: checked
        })
    }
    generate_qr_code() {
        var final_url = ''
        var source_url = this.state.qr_url;
        var utm_source = this.state.channel_type_value;
        var append_utm_source="";
        var utm_campaign = this.state.channel_value;
        var append_utm_campaign="";
        var utm_term = this.state.utm_term;
        var append_utm_term="";
        var utm_content = this.state.utm_content;
        var append_utm_content="";
        var product = this.state.product;
        var append_product="";

        if(utm_source!=""){
            append_utm_source = '&utm_source='+utm_source;
        }
        if(utm_campaign!=""){
            append_utm_campaign = '&utm_campaign='+utm_campaign;
        }
        if(utm_term!=""){
            append_utm_term = '&utm_term='+utm_term;
        }
        if(utm_content!=""){
            append_utm_content = '&utm_content='+utm_content;
        }
        if(product!=""){
            append_product = '&product='+product;
        }
        if(this.state.redirect_type==='App') {
            final_url = source_url+append_utm_source+append_utm_campaign+append_utm_content+append_utm_term+append_product
        }
        if(this.state.redirect_type==='Web') {
            final_url = this.state.web_url+'?'+this.state.utm_code+append_utm_source+append_utm_campaign+append_utm_content+append_utm_term+append_product
        }
        if(this.state.product=='') {
            this.handleNotificationClick("tr", 3, "Please Select Product");
            return false;
        }
        if(this.state.channel_type=='') {
            this.handleNotificationClick("tr", 3, "Please Select Channel Type");
            return false;
        }
        if(this.state.channel=='') {
            this.handleNotificationClick("tr", 3, "Please Select Channel");
            return false;
        }
//         if(this.state.utm_term=='') {
//             this.handleNotificationClick("tr", 3, "Please Enter UTM Term");
//             return false;
//         }
        if(this.state.utm_content=='') {
            this.handleNotificationClick("tr", 3, "Please Enter UTM Content");
            return false;
        }
        if(this.state.redirect_type==='Web' && this.state.web_url==='') {
            this.handleNotificationClick("tr", 3, "Please Enter Redirect Url.");
            return false;
        }

        var data = {
             final_url:final_url,
             back_color:this.state.back_color,
             front_color:this.state.front_color,
             qr_outer_eyes_front_color:this.state.qr_outer_eyes_front_color
        }
        console.log(data)

        this.setState({
            is_loading_qr: true,
            is_download_disabled:true,
            show_qr_image: false
        })
        axios.post(config.get('API_URL')+'/CampaignModule/generate_qr_code/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            console.log(response.data)
            if(response.data.signedUrl) {
                this.handleNotificationClick("tr", 1, "QR Code Generated Successfully");
            }
            this.setState({
                qr_file_path_sparcs: response.data.qr_file_path_sparcs,
                qr_file_path_s3: response.data.uploadData.Location,
                is_qr_generated:true,
                is_download_disabled:false,
                is_loading_qr: false,
                show_qr_image: true,
                qr_image:response.data.signedUrl,
                qr_image_file_name:response.data.file_name
                })
        }).catch(err =>{
            this.setState({

                is_download_disabled:false,
                is_loading_qr: false
                })
            console.log(err);
            this.handleNotificationClick("tr", 3, `Error: ${err.message}`);
        })
    }
    downloadQR(e) {
        var fileName = this.state.qr_image_file_name;
        var keyName = "ccms_UTMQR";
        var data = {
            fileName:this.state.qr_image_file_name,
            keyName:"ccms_UTMQR"
        }
        console.log(data);
        axios.post(config.get('API_URL') + '/CampaignModule/download_s3_file', data, {
            responseType: 'blob',
            headers: {
              Authorization: ` ${localStorage.usertoken}`
            },
          }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Set the download attribute with the file name
            document.body.appendChild(link);
            link.click();
            link.remove(); // Remove the link from the DOM
          }).catch(error => {
            console.error('Error downloading the file:', error);
          });
    }
    check_duplicate(){
        var data = {
            campaign_name:this.state.campaign_name
        }
        if(this.state.campaign_name=='') {
            this.handleNotificationClick("tr", 3, "Please Enter Campaign Name");
            return false;
        }
        axios.post(config.get('API_URL') + '/CampaignModule/check_duplicate', data, {
            headers: {
              Authorization: ` ${localStorage.usertoken}`
            },
          }).then(response => {
              if (response.data.duplicate) {
                  this.handleNotificationClick("tr", 3, "Campaign name already exists!");
                  return false;

                } else {
                    this.create_campaign()
                }

              }).catch(error => {
            console.error('Error downloading the file:', error);
          });

    }
    create_campaign() {
        var source_url = this.state.qr_url;
        var utm_source = this.state.channel_type_value;
        var append_utm_source="";
        var utm_campaign = this.state.channel_value;
        var append_utm_campaign="";
        var utm_term = moment(new Date()).format('YYYYMMDD');
        var append_utm_term="";
        var utm_content = this.state.utm_content;
        var append_utm_content="";
        var product = this.state.product;
        var append_product="";
        var state = this.state.stateValue;
        var city = this.state.cityValue;
        var area = this.state.areaValue;
        var final_url= '';
        if(this.state.is_pan_india===true) {
            state = [{"label": "All", "value": "All"}];
            city = [{"label": "All", "value": "All"}];
            area = [{"label": "All", "value": "All"}];
        }
        if(this.state.is_pan_state===true) {
            city = [{"label": "All", "value": "All"}];
            area = [{"label": "All", "value": "All"}];
        }
        if(this.state.is_pan_city===true) {
            area = [{"label": "All", "value": "All"}];
        }
        if(utm_source!=""){
            append_utm_source = '&utm_source='+utm_source;
        }
        if(utm_campaign!=""){
            append_utm_campaign = '&utm_campaign='+utm_campaign;
        }
        if(utm_term!=""){
            append_utm_term = '&utm_term='+utm_term;
        }
        if(utm_content!=""){
            append_utm_content = '&utm_content='+utm_content;
        }
        if(product!=""){
            append_product = '&product='+product;
        }
        if(this.state.redirect_type==='App') {
            final_url = source_url+append_utm_source+append_utm_campaign+append_utm_content+append_utm_term+append_product
        }
        if(this.state.redirect_type==='Web') {
            final_url = this.state.web_url+'?'+this.state.utm_code+append_utm_source+append_utm_campaign+append_utm_content+append_utm_term+append_product
        }
        if(this.state.product=='') {
            this.handleNotificationClick("tr", 3, "Please Select Product");
            return false;
        }
        if(this.state.channel_type=='') {
            this.handleNotificationClick("tr", 3, "Please Select Channel Type");
            return false;
        }
        if(this.state.channel=='') {
            this.handleNotificationClick("tr", 3, "Please Select Channel");
            return false;
        }
        if(this.state.campaign_name=='') {
            this.handleNotificationClick("tr", 3, "Please Enter Campaign Name");
            return false;
        }
        if(this.state.utm_content=='') {
            this.handleNotificationClick("tr", 3, "Please Select UTM Content");
            return false;
        }
        if(this.state.start_date=='') {
            this.handleNotificationClick("tr", 3, "Please Select Start Date");
            return false;
        }
        if(this.state.end_date=='') {
            this.handleNotificationClick("tr", 3, "Please Select End Date");
            return false;
        }
        if(state=='') {
            this.handleNotificationClick("tr", 3, "Please Select State");
            return false;
        }
        if(city=='') {
            this.handleNotificationClick("tr", 3, "Please Select City");
            return false;
        }
        if(area=='') {
            this.handleNotificationClick("tr", 3, "Please Select Area");
            return false;
        }
        var date1 = this.state.start_date;
        var date2 = this.state.end_date;
        var time1 = moment(date1).format('YYYY-MM-DD');
        var time2 = moment(date2).format('YYYY-MM-DD');
        if(time2 < time1){
            this.handleNotificationClick("tr", 3, "End date must be greater than or equal start date");
            return false;
        }


        if(this.state.is_qr_generated===false) {
            this.handleNotificationClick("tr", 3, "Please Generate QR Code");
            return false;
        }
        const data = new FormData();
        data.append('file', this.state.AdvertisementFiles[0]);
        data.append('file_name', this.state.file_name);
        data.append('product', this.state.product);
        data.append('channel', this.state.channel);
        data.append('channel_type', this.state.channel_type);
        data.append('campaign_name', this.state.campaign_name);
        data.append('start_date', this.state.start_date);
        data.append('end_date', this.state.end_date);
        data.append('utm_term', utm_term);
        data.append('utm_content', this.state.utm_content);
        data.append('final_url', final_url);
        data.append('utm_code', this.state.utm_code);
        data.append('description', this.state.description);
        data.append('is_active', this.state.is_active);
        data.append('user_email', this.state.email);
        data.append('qr_file_path_sparcs', this.state.qr_file_path_sparcs);
        data.append('qr_file_path_s3', this.state.qr_file_path_s3);
        data.append('state', JSON.stringify(state));
        data.append('city', JSON.stringify(city));
        data.append('area', JSON.stringify(area));
        data.append('utm_source', utm_source);
        data.append('utm_campaign', utm_campaign);
        data.append('redirect_type', this.state.redirect_type);
        data.append('web_url', this.state.web_url);

        axios.post(config.get('API_URL') + '/CampaignModule/create_new_campaign/', data, {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
            }).then(response => {

                if (response.data.error) {
                    this.handleNotificationClick("tr", 3, "Something went wrong");
                } else {
                    this.handleNotificationClick("tr", 1, "Campaign created successfully");
                    this.reset_all()
                    setTimeout(function(){
                        this.redirect_to_campaign_list();
                    }.bind(this), 2000);
                }
            }).catch(err => {
                console.log(err)
            });
    }
    redirect_to_campaign_list(e) {
        const { history } = this.props;
        history.push('/admin/campaign-lists');
    }
    reset_all(e){
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            channel:"",
            channel_type:"",
            products:"",
            start_date: moment(new Date()).format('YYYY-MM-DD'),
            end_date: moment(new Date()).format('YYYY-MM-DD'),
            CampaignProductLists:[],
            productValue:"",
            product:"",
            ChannelTypeLists:[],
            channelTypeValue:"",
            channel_type:"",
            ChannelLists:[],
            channelValue:"",
            channel:"",
            BaseURL:"",
            LinkAppID:"",
            utm_code:'',
            utm_content:"",
            utm_term:"",
            qr_url:"",
            is_active:true,
            channel_value:"",
            channel_type_value:"",
            campaign_name:"",
            back_color:"",
            front_color:"",
            qr_outer_eyes_front_color:"",
            is_qr_generated:false,
            is_download_disabled:true,
            AdvertisementFiles:"",
            file_name:"",
            is_loading_qr: false,
            qr_file_path_sparcs:"",
            qr_file_path_s3:"",
            file_name: 'No file chosen',
            description:"",
            UtmContentValue:[],
            stateValue:[],
            state_id:"",
            cityValue:[],
            city_id:"",
            area:"",
            areaValue:[],
        })
        setTimeout(function(){
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleFromChange = date => {
        var start_date1 = moment(date).format('YYYY-MM-DD');
        //alert(start_date1);
        this.setState({
            start_date: start_date1

        });
    };

    handleToChange = date => {
         var end_date2 = moment(date).format('YYYY-MM-DD');
        //alert(end_date2);
        this.setState({
            end_date: end_date2,

        });
    };
     onRedirectTypeChanged = e => {
        const {name, value} = e.target;
        this.setState({
            [name]: value,
            is_qr_generated:false
        });
    };
    render() {

        var source_url = this.state.qr_url;
        var utm_source = this.state.channel_type_value;
        var append_utm_source="";
        var utm_campaign = this.state.channel_value;
        var append_utm_campaign="";
        var utm_term = this.state.utm_term;
        var append_utm_term="";
        var utm_content = this.state.utm_content;
        var append_utm_content="";
        var product = this.state.product;
        var append_product="";
        console.log(this.state.utm_term)
        if(utm_source!=""){
            append_utm_source = '&utm_source='+utm_source;
        }
        if(utm_campaign!=""){
            append_utm_campaign = '&utm_campaign='+utm_campaign;
        }
        if(utm_term!=""){
            append_utm_term = '&utm_term='+utm_term;
        }
        if(utm_content!=""){
            append_utm_content = '&utm_content='+utm_content;
        }
        if(product!=""){
            append_product = '&product='+product;
        }
        var final_url = source_url+append_utm_source+append_utm_campaign+append_utm_content+append_utm_term+append_product
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }
    const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "32px",

            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "35px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="">
                                <div className="content">
                                    <div className="row">
                                        <div className="col-xs-12 padd-5">
                                            <div className="card title-card-bottom-space">
                                                <div className="header">
                                                    <h4 className="title">Create New Campaign</h4>
                                                    <p className="category"></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="content">

                                    <div className="row">



                                                <div className="col-lg-8 padd-5">
                                                    <div className="card add-camp-con">
                                                        <div className="content">
  <div className="row">
    <div>
      <div className="col-md-4">
        <div className="form-group">
          <label> Product </label>
          <Select
            name="pvalue"
            value={this.state.productValue}
            styles={reactSelectStyles}
            className="report-listbox"
            isClearable={true}
            onChange={this.changeProduct.bind(this)}
            options={this.state.CampaignProductLists}
            placeholder="Select Product"
          />
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label> Channel Type(From) </label>
          <Select
            name="pvalue"
            value={this.state.channelTypeValue}
            styles={reactSelectStyles}
            className="report-listbox"
            isClearable={true}
            onChange={(selectedOption) => {
                if (selectedOption === null) {
                    this.changeChannelType(null);
                } else {
                    this.changeChannelType(selectedOption);
                }
            }}
            options={this.state.ChannelTypeLists}
            placeholder="Select Channel Type"
          />
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label> Channel</label>
          <Select
            name="pvalue"
            value={this.state.channelValue}
            styles={reactSelectStyles}
            className="report-listbox"
            isClearable={true}
            onChange={(selectedOption) => {
                if (selectedOption === null) {
                    this.changeChannel(null);
                } else {
                    this.changeChannel(selectedOption);
                }
            }}
            options={this.state.ChannelLists}
            placeholder="Select Channel"
          />
        </div>
        <div className="clearfix"></div>
      </div>

      <div className="clearfix"></div>
    </div>
    <div>
      <div className="col-md-4">
        <div className="form-group">
        <label>Campaign Name </label>
        <Input
          id="campaign_name"
          name="campaign_name"
          value={this.state.campaign_name}
          onChange={this.onChangeInput.bind(this)}
        />
        </div>
        <div className="clearfix"></div>
      </div>

      <div className="col-md-4">
        <div className="form-group">
          <label>UTM Content</label>
          <Select
            name="pvalue"
            value={this.state.UtmContentValue}
            styles={reactSelectStyles}
            className="report-listbox"
            isClearable={true}
            onChange={this.changeUtmContent.bind(this)}
            options={this.state.UtmContentLists}
            placeholder="Select UTM Content"
          />
        </div>
      </div>
      <div className="col-md-2">
          <div className="form-group">
        <label> Start Date </label>
        <DatePicker
          dateFormat="d MMM yyyy"
          selected={Date.parse(this.state.start_date)}
          onChange={this.handleFromChange}
        />
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="col-md-2">
          <div className="form-group">
        <label> End Date </label>
        <DatePicker
          dateFormat="d MMM yyyy"
          selected={Date.parse(this.state.end_date)}
          onChange={this.handleToChange}
        />
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="clearfix"></div>
    </div>
    <div>
{/*       <div className="col-md-5"> */}
{/*         <div className="form-group"> */}
{/*           <label>UTM Term</label> */}
{/*           <Input */}
{/*             id="utm_term" */}
{/*             name="utm_term" */}
{/*             value={this.state.utm_term} */}
{/*             onChange={this.onChangeInput.bind(this)} */}

{/*           /> */}
{/*         </div> */}
{/*       </div> */}

        <div className="col-md-4">
            <div className="form-group">
              <label>State</label>
              <ReactMultiSelectCheckboxes name="state"
                    isMulti
                    components={{ MenuList }}
                    value={this.state.stateValue}
                    styles={customStyles} className="report-listbox"
                    isClearable={false}
                    onChange={this.changeState.bind(this,'')}
                    options={this.state.stateLists}
                    placeholderButtonLabel="Select [State]"
                    />
            </div>
       </div>
       <div className="col-md-4">
            <div className="form-group">
              <label>City</label>
              <div className={`${this.state.is_pan_india ? 'disabled-form-group' : ''}`}>
              <ReactMultiSelectCheckboxes name="city"
                    isMulti
                    isLoading={this.state.city_loading}
                    components={{ MenuList }}
                    value={this.state.cityValue}
                    styles={customStyles}
                    className="report-listbox"

                    isClearable={false}
                    onChange={this.changeCity.bind(this,'')}
                    options={this.state.cityLists}
                    placeholderButtonLabel="Select [City]"

                    />
              </div>
            </div>
       </div>
       <div className="col-md-4">
            <div className="form-group">
              <label>Marketing Cluster</label>
               <div className={`${this.state.is_pan_state ? 'disabled-form-group' : ''}`}>
              <ReactMultiSelectCheckboxes name="area"
                    isMulti
                    components={{ MenuList }}
                    value={this.state.areaValue}
                    styles={customStyles} className="report-listbox"
                    isClearable={false}
                    onChange={this.changeArea.bind(this,'')}
                    options={this.state.areaLists}
                    placeholderButtonLabel="Select [Area]"

                    />
            </div>
            </div>
       </div>


      <div className="clearfix"></div>
    </div>
    <div>
      <div className="col-md-7">
        <div className="form-group">
          <label>Redirect Type&nbsp;&nbsp;<input type="radio" name="redirect_type"
               value="App"
               checked={this.state.redirect_type === 'App'}
               onChange={this.onRedirectTypeChanged} disabled={this.state.disableInput}/> &nbsp; Redirect to App Store/Play Store
               &nbsp;&nbsp;<input type="radio" name="redirect_type"
               value="Web"
               checked={this.state.redirect_type === 'Web'}
               onChange={this.onRedirectTypeChanged} disabled={this.state.disableInput}/> &nbsp; Redirect to Web</label>
          {this.state.redirect_type==='App'?
          <Input
            id="name"
            name="name"
            value={final_url}
            onChange={this.onChangeInput.bind(this)}
            disabled={true}
          />:null}
          {this.state.redirect_type==='Web'?
          <Input
            id="web_url"
            name="web_url"
            value={this.state.web_url}
            onChange={this.onChangeInput.bind(this)}
            disabled={false}
          />:null}
        </div>
      </div>
      <div className="col-md-3">
        <div className="form-group">
          <label>UTM Code</label>
            <Input
            id="name"
            name="name"
            value={this.state.utm_code}
//             onChange={this.onChangeInput.bind(this)}
            disabled={true}
          />
        </div>
      </div>
      <div className="col-md-2">
        <div className="form-group">
            <label>Is Active</label>
            <div>
                <Switch className="react-switch" height={20} width={50} name="is_active"
                onChange={this.updateStatus.bind(this)} checked={this.state.is_active}></Switch>
            </div>
        </div>
      </div>
      <div className="clearfix"></div>
    </div>
    <div>
      <div className="col-md-8">
        <label>Description:</label>
        <div className="">
          <textarea
            name="description"
            rows="4"
            placeholder=""
            id="formControlsTextarea"
            onChange={this.onChangeInput.bind(this)}
            className="form-control pricingDescription"
            value={this.state.description}
          ></textarea>
        </div>
        <div className="clearfix"></div>
      </div>
      <div className="col-md-4">
        <Dropzone multiple={false} onDrop={this.onPreviewDropFile}>
          {({ getRootProps, getInputProps }) => (
            <section>

              <div className="dropzone-container" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="">
                  <i className="pe-7s-cloud-upload dropzone-icon"></i>
                  <p className="dropzone-text">
                    Drop & Drop the Advertisement copy file here or Click.
                  </p>
                  <p className="font-10">
                    {this.state.file_name}
                  </p>
                </div>

              </div>

            </section>
          )}
        </Dropzone>
      </div>
      <div className="clearfix"></div>
    </div>


    <div>
      <div className="col-md-3">
        <label>&nbsp;</label>
        <div>
          <button className="campaignButton" role="button" onClick={this.check_duplicate.bind(this)}>
            Submit
          </button>
        </div>
      </div>
      <div className="clearfix"></div>
    </div>
  </div>
</div>

                                                    </div>
                                                </div>
                                                <div className="col-lg-4 padd-5">
                                                    <div className="card add-camp-con">
                                                        <div className="content">
                                                            {this.state.show_qr_image===true?
                                                            <div>
                                                                 <img src={this.state.qr_image} alt="logo_image" style={{width:'100%'}}/>
                                                             </div>:<div className="col-md-12"><div className="linear-background-qr"></div></div>}
                                                             <div className="col-md-6 padd-5">
            <button className="generateQRButton" role="button" onClick={this.generate_qr_code.bind(this)} disabled={this.state.is_loading_qr}>
              Generate QR Code
            </button></div>
            <div className="col-md-6 padd-5">
            <button className="downloadQRButton" role="button" disabled={this.state.is_download_disabled} onClick={this.downloadQR.bind(this)}>
              <i className="fa fa-download" aria-hidden="true"></i>Download PNG
            </button>
          </div><div className="clearfix"></div>
          <div>
              <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={5}
                                        color={'#666666'}
                                        loading={this.state.is_loading_qr}
                                    /> </div>

                                </div>
                            </div>
                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AddCampaign